import { Box } from "@mui/material"
import { Stack } from "@mui/system"
import React from "react"
import { AssignmentCard, AssignmentExamCard } from "../cards/AssignmentExamCard"
import FilterSort from "../ui/FilterSort"

export const Exams = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction={"row-reverse"} justifyContent="flex-start">
        <FilterSort />
      </Stack>
      <Stack>
        <AssignmentCard />
        <AssignmentExamCard />
        <AssignmentExamCard />
      </Stack>
    </Box>
  )
}
